import React from 'react';
import './AltReferralSection.css';

export default function AltReferralSection({
  badge           = 'Referral programme',
  headline        = 'Refer creators & receive 5% of their spendings for life',
  body            = 'Whenever they subscribe to Premsi+, tip someone, or buy a premium message — you earn. Share your link once, earn passively forever.',
  ctaLabel        = 'Get your referral link',
  ctaHref         = '/ambassador',
}) {
  return (
    <section id="referral" className="alt-referral" aria-labelledby="referral-heading">
      <div className="alt-referral__inner alt-container">
        <div className="alt-referral__text">
          <span className="alt-referral__badge">{badge}</span>
          <h2 id="referral-heading" className="alt-referral__headline">{headline}</h2>
          <p className="alt-referral__body">{body}</p>
        </div>
        <a href={ctaHref} className="alt-referral__cta">{ctaLabel} →</a>
      </div>
    </section>
  );
}
